import React from 'react';
import { Select } from '../../Select';
import FieldBox from '../../../../uikit/fields/FieldBox';
import { withFormikField } from '../../../../hoc/withFormikField';
export function SelectField(props) {
    var name = props.name, description = props.description, options = props.options, value = props.value, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, label = props.label, isOptional = props.isOptional, errors = props.errors, placeholder = props.placeholder;
    var error = errors && errors.length ? errors[0] : undefined;
    return (React.createElement(FieldBox, { name: name, description: description, label: label, isOptional: isOptional, error: error },
        React.createElement(Select, { name: name, options: options, value: value, placeholder: placeholder, error: !!error, onChange: onChange, onBlur: onBlur, onFocus: onFocus })));
}
export var SelectFormikField = (function () {
    return withFormikField(SelectField);
})();
